import { render, staticRenderFns } from "./jobinfo.vue?vue&type=template&id=7d480830&scoped=true"
import script from "./jobinfo.vue?vue&type=script&lang=js"
export * from "./jobinfo.vue?vue&type=script&lang=js"
import style0 from "./jobinfo.vue?vue&type=style&index=0&id=7d480830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d480830",
  null
  
)

export default component.exports